module.exports = __webpack_public_path__ + "img/logo-others.04863215.png";